import { render, staticRenderFns } from "./MediaPlayer.vue?vue&type=template&id=40c868f3&scoped=true"
import script from "./MediaPlayer.vue?vue&type=script&lang=js"
export * from "./MediaPlayer.vue?vue&type=script&lang=js"
import style0 from "./MediaPlayer.vue?vue&type=style&index=0&id=40c868f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c868f3",
  null
  
)

export default component.exports